/**
 * StoreReceiptPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabContent,
  InputFormTable,
} from 'components';
import { Input, Button, Spin, Empty } from 'antd';
import lodash from 'utils/Lodash';

const StoreReceiptPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    stores,
    isLoading,
    inputValue,
    defaultValue,
    currentShop,
    onSelect,
    onChange,
    onSubmit,
  } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * Form
   * --
   */
  const form = React.useMemo(() => {
    return [
      {
        label: '영수증',
        form: [
          {
            input: (
              <Input.TextArea
                placeholder="내용을 입력해주세요"
                style={{ height: 248, marginBottom: 15 }}
                value={inputValue?.receipt_information}
                onChange={(e) =>
                  onChange('receipt_information', e.target.value)
                }
                showCount={true}
                fullScreen={true}
                maxLength={1000}
              />
            ),
            fullscreen: true,
          },
        ],
      },
    ];

    // eslint-disable-next-line
  }, [currentShop, inputValue]);

  /* ===== RENDER ===== */
  return (
    <Spin spinning={isLoading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title size={3} style={{ marginBottom: 10 }}>
              매장별 영수증 관리
            </Title>

            {/* 정책목록 */}
            <Content
              maxWidth={'100%'}
              padding={'20px 16px'}
              className="boxShadow"
            >
              {stores?.length ? (
                <TabContent
                  activeKey={currentShop?.key ?? null}
                  onChange={(val) => onSelect(val?.key)}
                  items={stores?.map((_item) => ({
                    key: _item?.key,
                    label: _item?.shop_information_name,
                    children: (
                      <div>
                        <InputFormTable form={form} />
                        <div
                          style={{
                            textAlign: 'center',
                            marginTop: 14,
                          }}
                        >
                          <Button
                            type="primary"
                            onClick={() => onSubmit(_item.key)}
                            disabled={lodash.isObjEqual(
                              defaultValue,
                              inputValue
                            )}
                          >
                            저장
                          </Button>{' '}
                          <Button
                            type="default"
                            onClick={() => onChange('all', defaultValue)}
                          >
                            초기화
                          </Button>
                        </div>
                      </div>
                    ),
                  }))}
                />
              ) : (
                <Empty />
              )}
            </Content>
            {/* 정책목록 끝 */}
          </Col>
        </Row>
      </Content>
    </Spin>
  );
};

export default StoreReceiptPresenter;
